import { render } from "react-dom";
import "./index.css";
import Redirect from "./components/Redirect/Redirect";
import { BrowserRouter } from "react-router-dom";
import { initRollbar } from "./utils/rollbar";
import { analyticsService } from "./services/AnalyticsService";
import LogRocket from "logrocket";
import { rollbarAccessToken } from "./utils/env";
LogRocket.init("ofbugl/speaker-connect");
analyticsService.init();
initRollbar(process.env.REACT_APP_ENV, rollbarAccessToken);
const root = document.getElementById("root");

if (process.env.REACT_APP_ENV === "main") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

render(
  <BrowserRouter>
    <Redirect />
  </BrowserRouter>,
  root
);
